var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"packages-section-body has-top-border",class:[`card-size-${_vm.provider.products.length}`]},_vm._l((_vm.provider.products),function(p){return _c('package-card',{key:p.solution_id,attrs:{"product":p,"provider-slug":_vm.provider.slug}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }